import { useStore as useBaseStore } from "react-redux";
import { AppStore } from "~/store";

export function useStore(): AppStore {
  return useBaseStore();
}
